import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

export const Root = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    min-height: 192px;
    height: 192px;
    padding: 0 4px;
    border-right: none;
    font-size: 14px;
    width: 250px;
    background-color: white;
    border: 1px solid ${colours.grey[400]};
    border-top: none;
    border-left: none;
`;
});

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const FilterWrapper = styled.div`
  padding: 3px 10px;
`;

export const AssignmentLoadingWrapper = styled.div`
  margin-left: auto;
  height: 14px;
`;

export const DropdownTitle = styled.div`
  display: flex;
`;
